import { postFetch } from '../fetch';

import { apiConfig } from '../config';

interface PostTeacherTrainingCourseCodeRequest {
    'code': string,
}

interface PostTeacherTrainingCourseCodeResponse {
    'statusCode': string;
    'message': string // статус добавления по коду
    'user_id': number,
    'id': string,
    'course_entering_code': string;
}

export function postTeacherTrainingCourseCode({ code }: PostTeacherTrainingCourseCodeRequest)
    : Promise<PostTeacherTrainingCourseCodeResponse> {
    const { apiPostUserTeacherTrainingCourseCode } = apiConfig.getStaticUrls();

    return postFetch(apiPostUserTeacherTrainingCourseCode, {
        'course_entering_code': code,
    });
}
